<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <ResponseAlert ref="response" />
        <div class="col-sm-12 mb-2 d-flex justify-content-between align-items-center flex-column flex-md-row">
          <div class="col-md-4 col-12 px-0 order-1 order-md-0">
            <div class="input-group">
              <input
                v-model="config.search"
                type="text"
                placeholder="Cari nama KFS"
                class="form-control form-control-sm"
                @keyup.enter="config.page = 1; get()"
              >
              <div class="input-group-append">
                <div
                  class="input-group-text"
                  @click="config.page = 1; get()"
                >
                  <feather-icon icon="SearchIcon" />
                </div>
              </div>
            </div>
          </div>
          <div class="order-0 order-md-1 mb-1 mb-md-0 full-width-responsive">
            <b-button
              v-if="hasPermission('filter/kfs-management')"
              v-b-modal.modal-advance-search
              type="submit"
              variant="secondary"
              class="btn-min-width rounded mr-1 full-width-responsive mb-1 mb-md-0"
            >
              Advance Filter
            </b-button>
            <custom-button
              text="Add KFS"
              :url="'/'+ config.uri+'/add'"
              permission="add/kfs-management"
              class-name="btn btn-primary display-table-cell pull-right rounded full-width-responsive"
            />
          </div>
        </div>
        <b-col sm="12">
          <div class="table-responsive">
            <table class="table b-table">
              <thead>
                <tr>
                  <th
                    v-for="(row, key) in config.headers"
                    :key="key"
                    :width="row.width"
                    :class="row.class"
                  >
                    <a
                      v-if="row.value"
                      class="sort dark-font"
                      href="javascript:void(0)"
                      @click="sort(row.value)"
                    >
                      {{ row.title }}
                      <i
                        :id="row.value"
                        class="fa fa-sort"
                      />
                    </a>
                    <a
                      v-else
                      :id="row.value"
                      class="sort dark-font"
                      href="javascript:void(0)"
                    >
                      {{ row.title }}
                    </a>
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-if="config.total_data">
                  <tr
                    v-for="(row, key) in config.rows"
                    :key="key"
                  >
                    <td>{{ row.name }}</td>
                    <td>{{ truncate(row.address,30) }}</td>
                    <td>{{ row.phone }}</td>
                    <td>{{ row.owner }}</td>
                    <td>{{ row.uniqueId }}</td>
                    <td>{{ row.levelName }}</td>
                    <td>{{ row.since }}</td>
                    <td>{{ row.poin }}</td>
                    <td>{{ row.status ? 'Aktif' : 'Tidak Aktif' }}</td>
                    <td align="center">
                      <div class="d-flex">
                        <custom-button
                          permission="detail/kfs-management"
                          :url="`/${config.uri}/${row.id}`"
                          title="Detail"
                          class-name="btn-action"
                        >
                          <feather-icon icon="EyeIcon" />
                        </custom-button>
                        <custom-button
                          permission="edit/kfs-management"
                          :url="`/${config.uri}/edit/${row.id}`"
                          title="Edit"
                          class-name="btn-action px-1"
                        >
                          <feather-icon icon="EditIcon" />
                        </custom-button>
                        <custom-button
                          type="button"
                          permission="delete/kfs-management"
                          title="Delete"
                          class-name="btn-action bg-transparent border-0 text-primary p-0"
                          @click="destroy(row.id)"
                        >
                          <feather-icon icon="TrashIcon" />
                        </custom-button>
                      </div>
                    </td>
                  </tr>
                </template>
                <tr v-if="!config.total_data">
                  <td
                    :colspan="config.headers.length"
                    align="center"
                  >
                    No data available.
                  </td>
                </tr>
              </tbody>
              <tfoot v-if="config.total_data">
                <tr>
                  <td
                    :colspan="config.headers.length"
                    class="p-0"
                  >
                    <div class="d-flex justify-content-between mt-2">
                      <b-form-select
                        v-model="config.per_page"
                        :options="perPageOptions"
                        class="w-auto"
                      />
                      <b-pagination
                        v-model="config.page"
                        :total-rows="config.total_data"
                        :per-page="config.per_page"
                        @change="gotoPage"
                      />
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <!-- Modal Advance Search -->
    <b-modal
      id="modal-advance-search"
      ref="modal-advance-search"
      centered
      title="Filter"
      hide-footer
    >
      <form
        @submit.prevent="advanceSearch"
      >
        <div class="animated fadeIn">
          <!-- Tag -->
          <b-row
            class="my-1"
            align-v="center"
          >
            <b-col sm="3">
              <label
                class="h5"
                for="tag"
              >Tag</label>
            </b-col>
            <b-col sm="9">
              <v-select
                id="tag"
                v-model="search.since"
                :clearable="false"
                label="name"
                placeholder="- Cari Tag -"
                :options="masters.regencies"
                :reduce="option => option"
                @search="debounceSearch"
                @input="setTagInfo"
              >
                <template #no-options="{ search, searching, loading }">
                  Tidak ditemukan hasil pencarian
                </template>
              </v-select>
            </b-col>
          </b-row>
          <!--  -->
          <!-- Owner -->
          <b-row
            class="my-1"
            align-v="center"
          >
            <b-col sm="3">
              <label
                class="h5"
                for="owner"
              >Owner</label>
            </b-col>
            <b-col sm="9">
              <b-form-select
                id="owner"
                v-model="search.accountId"
                placeholder="Pilih Owner"
                :options="masters.owners"
                value-field="profile.accountId"
                class="w-100"
              />
            </b-col>
          </b-row>
          <!--  -->
          <!-- Level KFS -->
          <b-row
            class="my-1"
            align-v="center"
          >
            <b-col sm="3">
              <label
                class="h5"
                for="level-kfs"
              >Level KFS</label>
            </b-col>
            <b-col sm="9">
              <b-form-select
                id="level-kfs"
                v-model="search.level"
                :options="masters.levels"
                value-field="id"
                text-field="name"
                class="w-100"
              />
            </b-col>
          </b-row>
          <!--  -->
          <div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-end mt-2">

            <b-button
              type="button"
              variant="outline-secondary"
              class="btn-min-width rounded"
              @click="exportExcel"
            >
              Export Data
            </b-button>
            <b-button
              type="button"
              variant="outline-primary"
              class="btn-min-width rounded mx-0 mx-md-1 my-1 my-md-0"
              @click="advanceSearch('reset')"
            >
              Reset
            </b-button>
            <b-button
              type="submit"
              variant="primary"
              class="btn-min-width rounded"
              @click="advanceSearch"
            >
              Simpan
            </b-button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import { truncate, exportExcel } from '@/utils/helpers'
import {
  BCard, BRow, BCol, BPagination, BFormSelect, BButton,
} from 'bootstrap-vue'
import api from '@/utils/api'

export default {
  name: 'ListKFS',
  metaInfo: {
    title: 'List KFS',
  },
  components: {
    BCard,
    BRow,
    BCol,
    BPagination,
    BFormSelect,
    BButton,
    vSelect,
  },
  data() {
    return {
      config: {
        uri: this.$route.meta.link,
        api: api.kfs,
        rows: [],
        additional_params: {
          accountId: null,
          level: null,
          since: null,
        },
        total_data: 0,
        total_page: 0,
        per_page: 10,
        page: 1,
        orderby: 'id',
        sort: 'desc',
        search: '',
        headers: [{
          title: 'KFS',
          value: 'name',
          align: 'text-left',
          width: '15%',
        }, {
          title: 'Alamat',
          value: 'address',
          align: 'text-left',
          width: '25%',
        }, {
          title: 'No Telepon',
          value: '',
          align: 'text-left',
          width: '10%',
        }, {
          title: 'Owner',
          value: 'owner',
          align: 'text-left',
          width: '10%',
        }, {
          title: 'Mitra ID',
          value: 'uniqueId',
          align: 'text-left',
          width: '10%',
        }, {
          title: 'Level',
          value: 'levelName',
          align: 'text-left',
          width: '10%',
        }, {
          title: 'Tags',
          value: 'since',
          align: 'text-left',
          width: '10%',
        }, {
          title: 'Point',
          value: 'poin',
          align: 'text-left',
          width: '5%',
        }, {
          title: 'Status',
          value: 'status',
          align: 'text-left',
          width: '5%',
        }, {
          title: 'Action',
          value: '',
          class: 'text-center',
          width: '5%',
        }],
      },
      masters: {
        regencies: [],
        owners: [
          {
            text: '- Pilih Owner -',
            profile: {
              accountId: null,
            },
          },
        ],
        levels: [
          {
            name: '- Pilih Level KFS -',
            id: null,
          },
        ],
      },
      search: {
        accountId: null,
        level: null,
        since: null,
      },
      truncate,
    }
  },
  computed: {
    perPageOptions() {
      return this.$store.state.app.perPageOptions
    },
    perPage() {
      return this.config.per_page
    },
  },
  watch: {
    perPage() {
      this.config.page = 1
      this.get()
    },
  },
  created() {
    const _ = this
    _.get()
    _.getListOption()
  },
  methods: {
    get() {
      this.$table.get(this.config)
    },
    sort(orderby) {
      if (orderby !== '') this.$table.sort(this.config, orderby)
    },
    gotoPage(page) {
      this.$table.gotoPage(this.config, page)
    },
    destroy(id) {
      this.$swal({
        title: 'Perhatian',
        text: 'Apakah anda yakin akan menghapus data ini?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$axios.delete(`${api.kfs}/${id}`)
            .then(res => {
              this.$refs.response.setResponse(res.data.message, 'success')
              this.get()
            })
            .catch(error => this.$refs.response.setResponse(error.response.data, 'danger'))
        }
      })
    },
    getListOption() {
      const getOwners = this.$axios.get(`${api.list_owner}`)
      const getLevelKFS = this.$axios.get(`${api.level}`)
      const getRegencies = this.$axios.get(`${api.list_regency}`)

      Promise.all([getOwners, getLevelKFS, getRegencies]).then(res => {
        const [owners, levels, regencies] = res
        owners.data.data.forEach(data => {
          data.text = data.profile.fullName
          this.masters.owners.push(data)
        })

        this.masters.levels = [...this.masters.levels, ...levels.data.data.rows]
        this.masters.regencies = [...regencies.data.data.rows]
      })
    },
    setTagInfo(data) {
      this.search.since = data.name
    },
    debounceSearch(value) {
      if (value !== '') {
        this.search.since = value
        clearTimeout(this.debounce)
        this.debounce = setTimeout(async () => {
          const response = await this.handleSearchTag()
          this.masters.regencies = [...response]
        }, 500)
      }
    },
    async handleSearchTag() {
      const res = await this.$axios.get(`${api.list_regency}?search=${this.search.since}`)
      return res.data.data.rows
    },
    advanceSearch(value) {
      if (value === 'reset') {
        this.config.additional_params.accountId = this.search.accountId = null
        this.config.additional_params.level = this.search.level = null
        this.config.additional_params.since = this.search.since = null
      } else {
        if (this.search.accountId) this.config.additional_params.accountId = this.search.accountId
        if (this.search.level) this.config.additional_params.level = this.search.level
        if (this.search.since) this.config.additional_params.since = this.search.since
      }
      this.config.page = 1
      this.get()
      this.$bvModal.hide('modal-advance-search')
    },

    exportExcel() {
      exportExcel('List KFS', `${api.kfs}/export`, this.search)
    },
  },
}
</script>
